<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.news.news') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.mobile_feature.news.news'),
            href: '/news'
          },
          { text: $t('administration.mobile_feature.news.edit'), active: true }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row form-group m-b-15">
              <div class="col-md-12 text-center">
                <div id="img-frame" class="text-center">
                  <label for="feature_image" id="label_feature_image">
                    <img :src="featureImageSrc" @error="onError()" />
                  </label>
                  <input
                    type="file"
                    id="feature_image"
                    ref="feature_image"
                    accept="image/*"
                    @change="onFileSelected"
                  />
                </div>
                <span
                  ><i>{{
                    $t('administration.mobile_feature.news.feature_image')
                  }}</i></span
                >
              </div>
            </div>
            <div class="row form-group m-b-15">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.mobile_feature.news.title') }}
                  <span class="text-danger">*</span></label
                >
                <textarea
                  rows="2"
                  v-model="model.title"
                  @input="makeSlug"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('title') }"
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('title')">
                  {{ errors.first('title') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  >{{ $t('administration.mobile_feature.news.slug') }}
                  <span class="text-danger">*</span></label
                >
                <textarea
                  rows="2"
                  v-model="model.slug"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('slug') }"
                  readonly
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('slug')">
                  {{ errors.first('slug') }}
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <ts-card>
          <ts-card-wrapper style="height: fit-content;">
            <ts-tabs target="gTab">
              <ts-tab>
                <span :class="{ 'text-danger': errors.has('content_en') }">
                  {{ $t('administration.mobile_feature.news.content') }}
                  <span class="text-danger">*</span>
                </span>
              </ts-tab>
            </ts-tabs>
            <ts-tab-panes name="gTab">
              <ts-tab-pane>
                <VueEditor
                  v-model="model.content_en"
                  :editor-toolbar="customToolbar"
                  useCustomImageHandler
                  @imageAdded="handleImageAdded"
                />
              </ts-tab-pane>
            </ts-tab-panes>
            <div class="row">
              <div class="col-sm-4 text-left mt-2">
                <span
                  v-if="errors.has('content_en')"
                  :class="{ 'text-danger': errors.has('content_en') }"
                >
                  {{ errors.first('content_en') }}
                </span>
              </div>
              <div class="col-sm-8 text-right mt-2">
                <ts-button
                  class="btn-primary mt-2"
                  @click.prevent="update"
                  :waiting="waiting"
                >
                  {{ $t('update') }}
                </ts-button>
                <ts-button
                  class="mt-2 ml-2"
                  @click="$router.push({ name: 'news' })"
                >
                  {{ $t('cancel') }}
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'news-edit',
  components: { VueEditor },
  data() {
    return {
      model: {
        news_id: '',
        title: '',
        slug: '',
        content_kh: '',
        content_en: '',
        feature_image: ''
      },
      waiting: false,
      featureImageSrc: require('../../assets/default-image.png'),
      errors: new Errors(),
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  created() {
    // this.readImage()
    this.setEditData()
  },
  computed: {
    ...mapState('news', ['edit_data'])
  },
  methods: {
    onFileSelected() {
      let file = null
      if (this.$refs.feature_image) {
        file = this.$refs.feature_image.files[0]
      }
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.featureImageSrc = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.featureImageSrc = require('../../assets/default-image.png')

          this.$toasted.error('invalid file type!')
          this.$refs.feature_image.value = ''
        }
      }
    },

    makeSlug() {
      this.model.slug = this.model.title.replace(/\s+/g, '-')
    },

    uploadfile() {
      if (this.$refs.feature_image) {
        this.file = this.$refs.feature_image.files[0]
          ? this.$refs.feature_image.files[0]
          : null
        if (this.file) {
          let formData = new FormData()
          formData.append('feature_image', this.file)
          return this.$store.dispatch('news/uploadFile', formData)
        }
      }
      return this.edit_data.feature_image
    },

    async update() {
      this.errors = new Errors()
      this.waiting = true
      let file_upload_path = await this.uploadfile()
      this.$store
        .dispatch(
          'news/update',
          Object.assign({}, this.model, { feature_image: file_upload_path })
        )
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'news' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    readImage() {
      if (this.edit_data.feature_image != null)
        this.$store
          .dispatch('news/readImage', this.edit_data.news_id)
          .then(response => {
            this.featureImageSrc = response
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('image_content', file)
      this.$store
        .dispatch('news/newImageContent', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    setEditData() {
      this.model.news_id = this.edit_data.news_id
      this.model.title = this.edit_data.title
      this.model.slug = this.edit_data.slug
      this.model.content_kh = this.edit_data.content_kh
      this.model.content_en = this.edit_data.content_en
      this.model.feature_image = this.edit_data.feature_image
      this.featureImageSrc = this.edit_data.feature_image
        ? this.edit_data.feature_image
        : require('../../assets/default-image.png')
    },
    clearFormInput() {
      this.model.title = ''
      this.model.slug = ''
      ;(this.model.content_kh = ''), (this.model.content_en = '')
      this.$refs.feature_image.value = ''
      this.featureImageSrc = require('../../assets/default-image.png')
    },
    onError() {
      event
        ? (event.target.src = require('../../assets/default-image.png'))
        : null
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('news/RESET_STATE')
      this.$store.commit('news/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
<style>
.ql-editor {
  min-height: 23vh !important;
  height: 64vh !important;
  overflow-y: scroll !important;
}
</style>
<style scoped>
#feature_image {
  display: none;
}
#img-frame img {
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
#label_feature_image {
  cursor: pointer;
}

@import '~vue2-editor/dist/vue2-editor.css';

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
